var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { IdUrls } from "../../../constants/IdUrls";
import { IdStyles } from "../../../less/IdStyles";
import { selectShopLegalText } from "../../../selectors/selectShopInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { localizedUrls } from "../../../utils/i18n/localizedUrls";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { actionGameTrackingProviderSelect } from "../../game-tracking/shop/actionGameTrackingShop";
import { CurrencyFormat } from "../../generic/currency-format/CurrencyFormat";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TextLoca } from "../../generic/text/TextLoca";
import { IdTooltipAnchor } from "../../tooltip";
import { IdOfferType } from "../IdOfferType";
import { OfferButtonBuy } from "./OfferButtonBuy";
import { OfferHC } from "./OfferHC";
import { OfferLevelRewardPayment } from "./OfferLevelRewardPayment";
import { OfferRemainingTime } from "./OfferRemainingTime";
import { OfferRewards } from "./OfferRewards";
import { ShopPaymentProviderSelection } from "./ShopPaymentProviderSelection";
var dummyOffer = {
    backgroundColor: "transparent",
    baseGoldValue: 0,
    bonusGoldPercent: 0,
    bonusGoldValue: 0,
    imageName: IdLoca.empty,
    locaKeyEyecatcher: IdLoca.empty,
    locaKeyFlavour: IdLoca.empty,
    locaKeyTitle: IdLoca.empty,
    offerCharacteristicId: 1,
    onBuyClick: function () { return undefined; },
    onCloseClick: function () { return undefined; },
    providers: [
        {
            countryCode: "01",
            id: -1,
        },
    ],
    purchaseOfferNameId: "",
    purchasePoints: 0,
    remainingSeconds: -1,
    rewards: [],
    shopPackage: {
        currencyCode: "EUR",
        price: 0,
    },
    webBonusGold: 0,
};
var ShopPaymentPageDOM = /** @class */ (function (_super) {
    __extends(ShopPaymentPageDOM, _super);
    function ShopPaymentPageDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedProvider: undefined,
        };
        _this.getHeader = function () {
            var _a = _this.props, offer = _a.offer, onReturn = _a.onReturn;
            var locaKeyTitle = (offer || dummyOffer).locaKeyTitle;
            var showReturn = onReturn != undefined;
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: IdStyles.OfferHeader + " wooden-texture-background offer-header-container" },
                    React.createElement(TextLoca, { id: locaKeyTitle, className: "" + IdStyles.HeadlineOne })),
                showReturn && (React.createElement("div", { className: "shop-psp__header-return" },
                    React.createElement(TextLoca, { className: IdStyles.TextSmallSecondary, id: IdLoca.buttonBacktoOffers_web }),
                    React.createElement("div", { className: IdStyles.BackToOffersButton + " return-to-offers", onClick: onReturn },
                        React.createElement(Icon, { icon: IdIcon.WhiteArrowIcn, styleId: IdStyles.IconSmall }))))));
        };
        _this.getContent = function () {
            var offer = _this.props.offer || dummyOffer;
            var backgroundColor = offer.backgroundColor, onBuyClick = offer.onBuyClick, locaKeyTitle = offer.locaKeyTitle, remainingSeconds = offer.remainingSeconds, shopPackage = offer.shopPackage;
            var tintStyle = {
                backgroundColor: backgroundColor,
                border: "none",
                height: "100%",
                width: "100%",
            };
            var providers = _this.getFilteredProviders();
            var selectedProvider = _this.state.selectedProvider || providers[0];
            var rewardsComponent = _this.getReward(offer);
            var remainingTimeComponent;
            if (remainingSeconds && remainingSeconds > 0) {
                remainingTimeComponent = React.createElement(OfferRemainingTime, { remainingSeconds: remainingSeconds });
            }
            return (React.createElement("div", { className: IdStyles.OfferBackground + " offer-body__container shop-psp__container" },
                React.createElement("div", { className: IdStyles.OfferSlideshowBackground + " offer-container__tint", style: tintStyle }),
                React.createElement("div", { className: "shop-psp__reward-list-container" },
                    rewardsComponent,
                    remainingTimeComponent),
                React.createElement("div", { className: "shop-psp__details-container" },
                    React.createElement(ShopPaymentProviderSelection, { shopPackage: shopPackage, providers: providers, onProviderSelected: _this.onProviderSelected, selectedProvider: selectedProvider }),
                    React.createElement(TextLoca, { id: IdLoca.purchase_yourOrder_web, className: IdStyles.TextSmall + " shop-psp__order-text" }),
                    React.createElement("div", { className: IdStyles.ShopPurchaseOfferBackground + " shop-psp__offer-details" },
                        React.createElement("div", { className: "shop-psp__offer-title" },
                            React.createElement(TextLoca, { id: locaKeyTitle, className: "" + IdStyles.TextButtonHeading })),
                        React.createElement("div", { className: IdStyles.TextSmall + " shop-psp__offer-price text-right" },
                            React.createElement(TextLoca, { id: IdLoca.purchase_amount_web }),
                            "\u00A0",
                            React.createElement(CurrencyFormat, { amount: shopPackage.price || 0, currencyCode: shopPackage.currencyCode }),
                            _this.props.taxesText && (React.createElement("div", null,
                                React.createElement(TextLoca, { id: _this.props.taxesText }))))),
                    React.createElement(TextLoca, { id: IdLoca.purchase_desc_web, className: IdStyles.TextSmallSecondary + " shop-psp__offer-description" }),
                    React.createElement("div", { className: "shop-psp__purchase-btn" },
                        React.createElement(OfferButtonBuy, { idLocaKay: IdLoca.purchase_checkOut_btn_web, shopPackage: offer.shopPackage, onClick: function () { return onBuyClick(offer, selectedProvider); } })))));
        };
        _this.getReward = function (offer) {
            var type = offer.type;
            if (type === IdOfferType.HCOffer) {
                return React.createElement(OfferHC, { offer: offer, disableBuyButton: true });
            }
            else if (type === IdOfferType.GrowthFund) {
                return React.createElement(OfferLevelRewardPayment, __assign({}, offer));
            }
            return React.createElement(OfferRewards, __assign({}, offer, { idTooltipAnchor: IdTooltipAnchor.Left }));
        };
        _this.getFooter = function () {
            var currLang = utilLoca.getCurrentLanguage();
            var companyUrl = IdUrls.companyUrl;
            var termsUrl = localizedUrls.getLocalizedTermsUrl(currLang);
            var privacyUrl = localizedUrls.getLocalizedPrivacyUrl(currLang);
            var withdrawalUrl = localizedUrls.getLocalizedWithdrawalUrl(currLang);
            var supportUrl = localizedUrls.getLocalizedSupportUrl(currLang, _this.props.userName || "");
            return (React.createElement("div", { className: "shop-psp__footer-container" },
                React.createElement("div", { className: IdStyles.TextSmallSecondary + " shop-psp__footer-column" },
                    React.createElement(TextLoca, { id: IdLoca.purchase_vatIncluded_web, className: "shop-psp__footer-text-block" }),
                    React.createElement("a", { className: IdStyles.TextLinkSmall, target: "_blank", href: termsUrl },
                        React.createElement(TextLoca, { id: IdLoca.purchase_termsConditions_web, className: "shop-psp__footer-text-block" })),
                    React.createElement("a", { className: IdStyles.TextLinkSmall, target: "_blank", href: privacyUrl },
                        React.createElement(TextLoca, { id: IdLoca.purchase_privacyPolicy_web, className: "shop-psp__footer-text-block" })),
                    React.createElement("a", { className: IdStyles.TextLinkSmall, target: "_blank", href: withdrawalUrl },
                        React.createElement(TextLoca, { id: IdLoca.purchase_withdrawal_web, className: "shop-psp__footer-text-block" }))),
                React.createElement("div", { className: "shop-psp__footer-column center" },
                    React.createElement("a", { target: "_blank", href: supportUrl },
                        React.createElement(TextLoca, { id: IdLoca.settingsMenu_support, className: IdStyles.ShopSupportButton + " " + IdStyles.TextBoldPrimary + " shop-psp__support-btn" }))),
                React.createElement("div", { className: IdStyles.TextSmallSecondary + " shop-psp__footer-column right" },
                    React.createElement("div", { className: "shop-psp__footer-text-block" },
                        React.createElement(TextLoca, { id: IdLoca.purchase_disclaimer1_web }),
                        "\u00A0",
                        React.createElement("a", { className: IdStyles.TextLinkSmall, target: "_blank", href: companyUrl },
                            React.createElement(TextLoca, { id: IdLoca.purchase_disclaimer2_web })),
                        "\u00A0",
                        React.createElement(TextLoca, { id: IdLoca.purchase_disclaimer3_web })),
                    React.createElement(TextLoca, { id: IdLoca.purchase_disclaimer4_web, className: "shop-psp__footer-text-block" }),
                    React.createElement(TextLoca, { id: IdLoca.purchase_disclaimer5_web, className: "shop-psp__footer-text-block" }))));
        };
        _this.getFilteredProviders = function () {
            var _a = _this.props.offer || dummyOffer, providers = _a.providers, shopPackage = _a.shopPackage;
            return providers.filter(function (provider) {
                var max = provider.maxAmount || Number.MAX_VALUE;
                var min = provider.minAmount || 0;
                var price = shopPackage.price || Number.MAX_VALUE;
                var exists = (shopPackage.providerIds || []).indexOf(provider.id) !== -1;
                var fitsInLimits = utilNumber.clamp(price, min, max) === price;
                return exists && fitsInLimits;
            });
        };
        _this.onProviderSelected = function (provider) {
            var onProviderSelect = _this.props.onProviderSelect;
            _this.setState({
                selectedProvider: provider,
            });
            if (onProviderSelect && provider) {
                onProviderSelect(utilNumber.format(provider.id));
            }
        };
        return _this;
    }
    ShopPaymentPageDOM.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
        return this.props.offer == undefined || nextProps.offer != undefined;
    };
    ShopPaymentPageDOM.prototype.render = function () {
        var header = this.getHeader();
        var content = this.getContent();
        var footer = this.getFooter();
        return (React.createElement("div", { className: "offer-container shop-psp" },
            header,
            content,
            footer));
    };
    return ShopPaymentPageDOM;
}(React.Component));
var mapState = function (state) { return ({
    taxesText: selectShopLegalText(state),
    userName: state.playerInfo.name || "",
}); };
var mapDispatch = function (dispatch) { return ({
    onProviderSelect: function (providerId) {
        return dispatch(actionGameTrackingProviderSelect(providerId));
    },
}); };
export var ShopPaymentPage = connect(mapState, mapDispatch)(ShopPaymentPageDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/ShopPaymentPage.tsx
// module id = 963
// module chunks = 3